window.jQuery = require("jquery");
window.$ = require("jquery");

require('../node_modules/jquery-ui/ui/core');
require('../node_modules/jquery-ui/ui/widgets/sortable');

require("inflection");
window.moment = require('moment/moment.js');


require("angular");
require("angular-ui-bootstrap/dist/ui-bootstrap-tpls");
require("@uirouter/angularjs");
require("angular-animate");
require("angular-sanitize");
require("angular-cookies");
require("nginflection");
require("angular-bootstrap-toggle-switch");
require("angular-xeditable");
require("angularjs-scroll-glue");
require("angular-ui-sortable");

require('bootstrap-daterangepicker/daterangepicker.js');
require('angular-daterangepicker/js/angular-daterangepicker.js');

window.firebase = require('firebase');

require("@iamadamjowett/angular-click-outside");

window._ = require("lodash/lodash");

window.compare = require("compare");
window.momentToDate = require("momentToDate");
window.parseBoolean = require("parseBoolean");
window.X2JS = require("xml2json");

// require('./assets/js/jw/jwplayer');


// WEBPACK FOOTER //
// ./app.v2/entry.vendor.js